import React from "react";
import * as PropTypes from "prop-types";
import { dataPropType } from "../../propTypes";
import { withStyles } from "@material-ui/core";
import classNames from "classnames";
import CloseIcon from "@material-ui/icons/Close";
import styleConstants from "../../styleConstants";
import CountryExplorerCurrentChartWidget from "./CountryExplorerCurrentChartWidget";
import CountryExplorerProjectionChartWidget from "./CountryExplorerProjectionChartWidget";

const styles = {
  appBar: {
    position: "fixed",
    width: "100%",
    top: styleConstants.toolbarHeight,
    backgroundColor: "white",
    zIndex: 1
  },
  chart: {
    marginTop: "2rem",
    paddingBottom: "2rem"
  },
  close: {
    cursor: "pointer"
  },
  container: {
    marginTop: styleConstants.toolbarHeight,
    marginBottom: "2rem"
  },
  content: {
    margin: "8rem 4rem 4rem",
    paddingBottom: "2rem"
  },
  drawerTitle: {
    color: styleConstants.colors.themeBlue
  },
  toolbar: {
    width: "100%",
    margin: "2rem 0 2rem 1rem",
    paddingRight: "2rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  }
};

const CountryExplorer = props => {
  const database = props.data.databases.core;
  const data = props.data.widgetData.countryExplorer;

  return (
    <div className={classNames("CountryExplorer", props.classes.container)}>
      <div className={props.classes.appBar}>
        <div className={props.classes.toolbar}>
          <h2 className={props.classes.drawerTitle}>Country Explorer</h2>

          <CloseIcon className={props.classes.close} onClick={props.onClose} />
        </div>
      </div>

      <div className={props.classes.content}>
        <div className={props.classes.chart}>
          <CountryExplorerCurrentChartWidget
            database={database}
            data={data.currentChart}
            onChange={props.onWidgetChange}
          />
        </div>

        <div className={props.classes.chart}>
          <CountryExplorerProjectionChartWidget
            database={database}
            data={data.projectionChart}
            onChange={props.onWidgetChange}
          />
        </div>
      </div>
    </div>
  );
};

CountryExplorer.propTypes = {
  data: dataPropType,
  onWidgetChange: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
};

export const calculateChartHeight = (height, countryCount) => {
  const normalizedChartHeight = 1000;
  const normalizedPlotHeight = 924;
  const normalizedCountryCount = 34;

  return (
    (normalizedChartHeight -
      normalizedPlotHeight +
      countryCount * (normalizedPlotHeight / normalizedCountryCount)) *
    (height / normalizedChartHeight)
  );
};

export default withStyles(styles)(CountryExplorer);
